export default { // 亚马逊
  addShopAccount: './cs/mail/acccount/addAccountShop', // 新增亚马逊账户
  editShopAccount: './cs/mail/acccount/modifyAmazonAccount', // 修改亚马逊账户
  validateEm: './cs/mail/acccount/vailEmailAdress', // 验证邮箱
  getShopList: './cs/mail/acccount/accountShopList', // 亚马逊平台初始化列表
  syncAccount: './cs/mail/acccount/syncOldAmazonAccount', // 同步老erp的数据
  enableAndUnuse: './cs/mail/acccount/enbleAmazonAccount' // 账户启用停用
};
